import PropTypes from 'prop-types';

import {
  ITALIC_DEFINITIONS,
  onKeyDownMark,
} from '@xing-com/content-editor-plugin-helpers';

import { ITALIC_KEYBOARD_SHORTCUT } from './constants';
import { Italic } from './Italic';

const ItalicPlugin = ({ className, ITALIC_TAG, ...attributes } = {}) => ({
  renderLeaf: Italic({ className, ITALIC_TAG, ...attributes }),
  onKeyDown: onKeyDownMark({
    mark: ITALIC_DEFINITIONS.type,
    hotkey: ITALIC_KEYBOARD_SHORTCUT,
  }),
});

ItalicPlugin.propTypes = {
  className: PropTypes.string,
  ITALIC_TAG: PropTypes.node,
};

export { ItalicPlugin };
